<!--
 * @Author: jian.li jian.li@genetronhealth.com
 * @Date: 2023-01-03 16:40:46
 * @LastEditors: jian.li jian.li@genetronhealth.com
 * @LastEditTime: 2023-01-28 17:35:04
 * @FilePath: \FSZ-GALILEO-WEB\genetron-web\genetron-h5\src\views\reportQuery\approvalAuthorization.vue
 * @Description: 
-->
<template>
  <div class="backgroundImg">
    <div id="" style="position: relative">
      <div class="img">
        <img src="@/assets/编组@2x.png" alt="" />
      </div>
      <div class="title">请联系泛生子人员</div>
      <div class="text">
        恭喜您已完成授权，请联系泛生子人员！泛生子人员将为您发送电子合同签署信息，打开链接即可进行合同签署。
      </div>
      <div class="bottomImg">
        <img src="@/assets/logo@2x.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.img {
  padding-top: 70px;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  img {
    width: 190px;
    height: 194px;
  }
}
.title {
  text-align: center;
  font-size: 22px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #2f354d;
  line-height: 32px;
}
.text {
  width: 263px;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5f697d;
  margin: 0 auto;
  margin-top: 20px;
}
.bottomImg {
  position: fixed;
  bottom: 32px;
  left: 50%;
  transform: translate(-50%, -50%);
  img {
    width: 100px;
    height: 22px;
  }
}
.backgroundImg {
  width: 100vw;
  height: 100vh;
  background-image: url("../../assets/编组\ 4@2x.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
</style>
